import { render, staticRenderFns } from "./MedicalHistoryModal.vue?vue&type=template&id=710c7ab8&"
import script from "./MedicalHistoryModal.vue?vue&type=script&lang=js&"
export * from "./MedicalHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports